/* eslint-disable indent */
/* eslint-disable class-methods-use-this */
// eslint-disable-next-line object-curly-newline
import {
  getFirestore,
  getDocs,
  getDoc,
  doc,
  collection,
  query,
  DocumentData,
  DocumentSnapshot,
  setDoc,
  where,
  writeBatch,
  orderBy,
  startAfter,
  limit
} from "firebase/firestore";
import { EventTracker } from "@models/EventTracker";
import { getFunctions, httpsCallable } from "firebase/functions";
import Config from "@/config/Config";

class EventManagerDataService {
  eventCollectionName = "events";

  trackerCollectionName = "trackers";

  async getTrackers(
    eventId: string,
    handleDataReceived: (registrations: EventTracker[]) => void
  ): Promise<void> {
    const db = getFirestore();

    const eventDoc = doc(db, this.eventCollectionName, eventId);

    let hasData = true;
    let lastVisible = null;
    while (hasData) {
      const managersQuery = (lastVisible ? query(collection(eventDoc, this.trackerCollectionName),
        orderBy("participantId"),
        startAfter(lastVisible),
        limit(50)
      ) : query(collection(eventDoc, this.trackerCollectionName),
        orderBy("participantId"),
        limit(50)
      )) as any;

      const data = await getDocs(managersQuery);
      lastVisible = data.docs[data.docs.length-1]
      const results: EventTracker[] = [];

      const managerPromises: Promise<DocumentSnapshot<DocumentData>>[] = [];
      data.forEach((item) => {
        results.push({ ...item.data() } as EventTracker);
      });

      handleDataReceived(results);
      hasData = results.length > 0;
    }
  }

  async getTrackersByParicipantIds(
    eventId: string,
    participantIds: string[]
  ): Promise<EventTracker[]> {
    const db = getFirestore();
    const eventDoc = doc(db, this.eventCollectionName, eventId);

    const participantTrackers = query(
      collection(eventDoc, this.trackerCollectionName),
      where("participantId", "in", participantIds)
    );

    const data = await getDocs(participantTrackers);
    const results: EventTracker[] = [];

    const trackerPromises: Promise<DocumentSnapshot<DocumentData>>[] = [];
    data.forEach((item) => {
      trackerPromises.push(getDoc(item.ref));
    });

    const participantDocumentSnapshots = await Promise.all(trackerPromises);
    participantDocumentSnapshots.forEach((trackerDoc) => {
      results.push({ ...trackerDoc.data() } as EventTracker);
    });
    return results;
  }

  async getTrackerByUserId(eventId: string, userId: string): Promise<EventTracker> {
    const db = getFirestore();

    const eventDoc = doc(db, this.eventCollectionName, eventId);

    const trackerRef = doc(
      collection(eventDoc, this.trackerCollectionName),
      // eslint-disable-next-line comma-dangle
      userId
    );

    const data = await getDoc(trackerRef);
    const results: EventTracker = { ...data.data() } as EventTracker;
    return results;
  }

  async save(eventId: string, eventTracker: EventTracker): Promise<EventTracker> {
    const db = getFirestore();
    const eventDoc = doc(db, this.eventCollectionName, eventId);
    const eventTrackerDoc = doc(eventDoc, this.trackerCollectionName, eventTracker.participantId);
    await setDoc(eventTrackerDoc, eventTracker);
    return eventTracker;
  }

  async saveAll(eventId: string, eventTrackers: EventTracker[]): Promise<void> {
    const db = getFirestore();
    const batch = writeBatch(db);
    eventTrackers.forEach((eventTracker) => {
      const eventDoc = doc(db, this.eventCollectionName, eventId);
      const eventTrackerDoc = doc(eventDoc, this.trackerCollectionName, eventTracker.participantId);
      batch.set(eventTrackerDoc, eventTracker);
    });

    await batch.commit();
  }
}
export default new EventManagerDataService();
